import { Component, OnInit, Input } from '@angular/core';
import { API_PDFService  } from '../../core/apiconfig';
import {
    LinkAnnotationService, BookmarkViewService, MagnificationService, ThumbnailViewService,
    ToolbarService, NavigationService, AnnotationService, TextSearchService, TextSelectionService, PrintService
} from '@syncfusion/ej2-angular-pdfviewer';
@Component({
  selector: 'Pnx-PDF',
  templateUrl: './pdf.control.html',
    styleUrls: ['./pdf.control.css'],
    providers: [LinkAnnotationService, BookmarkViewService, MagnificationService,
        ThumbnailViewService, ToolbarService, NavigationService, AnnotationService, TextSearchService, TextSelectionService, PrintService]
})
export class PdfControl implements OnInit {
    @Input() fileName: string;
    @Input() serviceURL: string;
    public serverActionSettings: any;
    public toolbarSettings = { showTooltip: true, toolbarItems: ['SearchOption', 'MagnificationTool', 'PrintOption', 'DownloadOption','PageNavigationTool'] };

    constructor() {
      
    }

    ngOnInit() {
  }    
}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/pdf.control.ts